(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["robingo-compare-controller"] && !Shopify.designMode) return;
  try {
    (()=>{
    const configNode=document.querySelector('[data-rg-compare-config]');
    if(!configNode)return;
    const config=JSON.parse(configNode.textContent),labels=config.labels,key='robingo-route-compare-v1';
    const bar=document.querySelector('[data-rg-compare-bar]'),announcement=document.querySelector('[data-rg-compare-announcement]');
    let selected=[];
    try{const saved=JSON.parse(sessionStorage.getItem(key)||'[]');if(Array.isArray(saved))selected=saved.filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h)).slice(0,3);}catch{}
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    function persist(){try{sessionStorage.setItem(key,JSON.stringify(selected));}catch{}}
    function update(){
      document.querySelectorAll('[data-rg-compare-toggle]').forEach(input=>input.checked=selected.includes(input.dataset.handle));
      if(bar){bar.hidden=!selected.length;bar.querySelector('[data-rg-compare-count]').textContent=labels.selected.replace('__COUNT__',selected.length);bar.querySelector('[data-rg-compare-open]').disabled=selected.length<2;}
    }
    document.addEventListener('change',event=>{
      const input=event.target.closest('[data-rg-compare-toggle]');if(!input)return;
      if(input.checked&&!selected.includes(input.dataset.handle)){
        if(selected.length>=3){input.checked=false;announcement.textContent=labels.maximum;return;}
        selected.push(input.dataset.handle);
      }else if(!input.checked)selected=selected.filter(h=>h!==input.dataset.handle);
      persist();update();announcement.textContent=labels.selected.replace('__COUNT__',selected.length);
    });
    document.addEventListener('click',event=>{if(event.target.closest('.rg-compare-toggle'))event.stopPropagation();},true);
    bar?.querySelector('[data-rg-compare-clear]').addEventListener('click',()=>{selected=[];persist();update();});
    bar?.querySelector('[data-rg-compare-open]').addEventListener('click',()=>{
      if(selected.length<2){announcement.textContent=labels.minimum;return;}
      const url=new URL(config.collection,location.origin);url.searchParams.set('view','compare');url.searchParams.set('products',selected.join(','));if(preview)url.searchParams.set('preview_theme_id',preview);window.open(url.href,'_blank','noopener');
    });
    update();
    new MutationObserver(mutations=>{if(mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-rg-compare-toggle]')||n.querySelector?.('[data-rg-compare-toggle]')))))update();}).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
    const page=document.querySelector('[data-rg-compare-page]');if(!page)return;
    if(bar)bar.hidden=true;
    const status=page.querySelector('[data-rg-compare-status]'),grid=page.querySelector('[data-rg-compare-grid]'),context=page.querySelector('[data-rg-compare-context]');
    const handles=[...new Set((new URL(location.href).searchParams.get('products')||'').split(','))].filter(h=>/^[a-z0-9-]+$/.test(h)).slice(0,3);
    if(handles.length<2){status.textContent=labels.empty;return;}
    const iso=d=>`${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,'0')}-${String(d.getUTCDate()).padStart(2,'0')}`;
    const dateObject=s=>new Date(s+'T12:00:00Z');
    const monthNames={jan:1,january:1,feb:2,february:2,mar:3,march:3,apr:4,april:4,may:5,jun:6,june:6,jul:7,july:7,aug:8,august:8,sep:9,sept:9,september:9,oct:10,october:10,nov:11,november:11,dec:12,december:12};
    function variantDate(value){if(/^\d{4}-\d{2}-\d{2}$/.test(value||''))return value;const m=String(value||'').trim().match(/^(\d{1,2})[-\s]+([A-Za-z]{3,9})[-\s,]+(\d{4})$/);if(!m||!monthNames[m[2].toLowerCase()])return null;return `${m[3]}-${String(monthNames[m[2].toLowerCase()]).padStart(2,'0')}-${String(Number(m[1])).padStart(2,'0')}`;}
    const today=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    const formatDate=s=>new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}).format(dateObject(s));
    const optionValues=v=>v.options||[v.option1,v.option2,v.option3].filter(Boolean);
    function eligibleVariants(trip,date){
      const a=trip.availability,periods=a.periods||[],matches=periods.filter(p=>p.start&&p.end&&date>=p.start&&date<=p.end);
      if(periods.length&&matches.length!==1)return [];
      return trip.variants.filter(v=>{
        if(!v.available)return false;
        const opts=optionValues(v),room=trip.roomIndex>=0?opts[trip.roomIndex]:null;
        if(!room||!/twin|double/i.test(room)||/solo|single/i.test(room))return false;
        if(trip.dateIndex>=0&&variantDate(opts[trip.dateIndex])!==date)return false;
        if(periods.length&&!opts.includes(matches[0].name))return false;
        return Number.isFinite(Number(v.price))&&Number(v.price)>0;
      });
    }
    function availableDates(trip){
      const a=trip.availability,start=dateObject(today);start.setUTCDate(start.getUTCDate()+Math.max(14,Number(a.lead)||0));
      const earliest=iso(start),pattern=String(a.pattern||'Daily').toLowerCase().replace(/\s+/g,'-');
      let candidates=[...new Set((a.dates||[]).concat(trip.dateIndex>=0?trip.variants.map(v=>variantDate(optionValues(v)[trip.dateIndex])).filter(Boolean):[]))];
      if(pattern==='daily'||pattern==='selected-weekdays'){
        const horizon=dateObject(today);horizon.setUTCDate(horizon.getUTCDate()+(Number(a.window)>0?Number(a.window):730));
        const end=a.end&&a.end<iso(horizon)?a.end:iso(horizon);
        for(let d=dateObject(earliest);iso(d)<=end;d.setUTCDate(d.getUTCDate()+1)){
          const weekday=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d.getUTCDay()];
          if(pattern==='daily'||(a.weekdays||[]).includes(weekday))candidates.push(iso(d));
        }
      }
      return [...new Set(candidates)].filter(s=>{
        if(s<earliest||(a.start&&s<a.start)||(a.end&&s>a.end)||(a.blackout||[]).includes(s))return false;
        if(Number(a.window)>0){const max=dateObject(today);max.setUTCDate(max.getUTCDate()+Number(a.window));if(s>iso(max))return false;}
        if(pattern==='specific-dates-only'&&!(a.dates||[]).includes(s))return false;
        return eligibleVariants(trip,s).length>0;
      }).sort();
    }
    const element=(tag,className,text)=>{const e=document.createElement(tag);if(className)e.className=className;if(text!==undefined)e.textContent=text;return e;};
    Promise.all(handles.map(async handle=>{
      const url=new URL(`${config.root.replace(/\/$/,'')}/products/${handle}`,location.origin);url.searchParams.set('view','compare-data');if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url.href,{credentials:'same-origin'});if(!response.ok)throw Error('Unavailable product');
      const trip=await response.json();if(trip.handle!==handle||String(trip.mode).toLowerCase()!=='multi-day tour')throw Error('Unsupported product');
      trip.roomIndex=trip.options.findIndex(n=>/^(room occupancy|room basis)$/i.test(n));trip.dateIndex=trip.options.findIndex(n=>/^(departure date|travel date)$/i.test(n));trip.dates=availableDates(trip);return trip;
    })).then(trips=>{
      const baseline=[...trips].sort((a,b)=>(parseInt(a.duration)||Infinity)-(parseInt(b.duration)||Infinity))[0];
      const baselineCities=new Set(baseline.cities.map(c=>c.id||c.name));
      const monthKey=date=>String(date||'').slice(0,7);
      const formatMonth=month=>new Intl.DateTimeFormat('en-GB',{month:'long',year:'numeric',timeZone:'UTC'}).format(dateObject(month+'-01'));
      const months=[...new Set(trips.flatMap(trip=>trip.dates.map(monthKey)))].filter(Boolean).sort();
      let chosenMonth=months[0]||'';
      const highlight=page.querySelector('[data-rg-compare-highlight]');
      highlight.hidden=false;
      highlight.querySelector('span').textContent=labels.highlight.replace('__DURATION__',baseline.duration||labels.missing);
      page.dataset.highlight='true';
      highlight.querySelector('input').addEventListener('change',event=>page.dataset.highlight=String(event.target.checked));
      if(months.length){
        const label=element('label','',labels.month),select=element('select');
        select.setAttribute('aria-label',labels.month);
        months.forEach(month=>{const option=element('option','',formatMonth(month));option.value=month;select.append(option);});
        label.append(select);
        context.append(label,element('span','rg-compare-month-hint',labels.monthHint));
        select.addEventListener('change',()=>{chosenMonth=select.value;render();});
      }else context.append(element('span','rg-compare-month-hint',labels.noMonths));
      function money(trip,cents){return new Intl.NumberFormat('en-GB',{style:'currency',currency:trip.currency,minimumFractionDigits:Number(cents)>=10000&&Number(cents)%100===0?0:2,maximumFractionDigits:2}).format(Number(cents)/100);}
      function render(){
        grid.replaceChildren();
        grid.style.setProperty('--rg-compare-columns',trips.length);
        status.hidden=true;
        trips.forEach(trip=>{
          const card=element('article','rg-compare-trip');
          card.append(element('h2','',trip.title),element('div','rg-compare-duration',trip.duration||labels.missing),element('div','rg-compare-label',labels.places));
          const places=element('ul','rg-compare-places');
          if(!trip.cities.length)places.append(element('li','',labels.missing));
          trip.cities.forEach(city=>places.append(element('li',baselineCities.has(city.id||city.name)?'':'rg-compare-extra',city.name||labels.missing)));
          card.append(places);
          const monthDates=trip.dates.filter(date=>monthKey(date)===chosenMonth);
          const monthVariants=monthDates.flatMap(date=>eligibleVariants(trip,date));
          const wrap=element('div','rg-compare-price-wrap');
          if(monthDates.length&&monthVariants.length){
            const min=Math.min(...monthVariants.map(variant=>Number(variant.price)));
            wrap.append(
              element('p','rg-compare-price',labels.fromPrice.replace('__PRICE__',money(trip,min))),
              element('p','rg-compare-caption',labels.perPerson),
              element('p','rg-compare-month-summary',monthDates.length===1?labels.departuresOne:labels.departuresOther.replace('__COUNT__',monthDates.length))
            );
            const dateList=element('ul','rg-compare-dates');
            monthDates.slice(0,3).forEach(date=>dateList.append(element('li','',formatDate(date))));
            if(monthDates.length>3)dateList.append(element('li','rg-compare-more',labels.moreDates.replace('__COUNT__',monthDates.length-3)));
            wrap.append(dateList);
          }else{
            wrap.append(element('p','rg-compare-no-departures',labels.noDepartures));
          }
          const link=element('a','rg-compare-view',labels.view),url=new URL(trip.url,location.origin);
          if(preview)url.searchParams.set('preview_theme_id',preview);
          link.href=url.href;
          link.target='_blank';
          link.rel='noopener';
          link.append(element('span','','↗'));
          wrap.append(link);
          card.append(wrap);
          grid.append(card);
        });
      }
      render();
    }).catch(()=>{status.hidden=false;status.textContent=labels.error;grid.replaceChildren();});
  })();
  } catch(e) { console.error(e); }
})();

})();
